import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function CustomCursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const [hover, setHover] = useState(false);

  const springConfig = { stiffness: 320, damping: 30, mass: 0.45 };
  const sx = useSpring(x, springConfig);
  const sy = useSpring(y, springConfig);

  const ringScale = useSpring(1, { stiffness: 260, damping: 22 });

  useEffect(() => {
    ringScale.set(hover ? 1.5 : 1);
  }, [hover, ringScale]);

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const onEnter = () => setHover(true);
    const onLeave = () => setHover(false);

    window.addEventListener("mousemove", move);

    const selector = "a, button, input, textarea, select, [data-cursor='hover'], [role='button']";
    const bind = () => {
      document.querySelectorAll(selector).forEach((el) => {
        el.addEventListener("mouseenter", onEnter);
        el.addEventListener("mouseleave", onLeave);
      });
    };
    bind();
    const mo = new MutationObserver(bind);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", move);
      mo.disconnect();
      document.querySelectorAll(selector).forEach((el) => {
        el.removeEventListener("mouseenter", onEnter);
        el.removeEventListener("mouseleave", onLeave);
      });
    };
  }, [x, y]);

  // Center transforms with translate(-50%, -50%) via offset
  const dotX = useTransform(sx, (v) => v - 4);
  const dotY = useTransform(sy, (v) => v - 4);
  const ringX = useTransform(sx, (v) => v - 16);
  const ringY = useTransform(sy, (v) => v - 16);

  return (
    <>
      <motion.div
        aria-hidden="true"
        className="hidden md:block fixed top-0 left-0 pointer-events-none z-[9999]"
        style={{
          x: dotX,
          y: dotY,
          width: 8,
          height: 8,
          borderRadius: "9999px",
          background: "#FF1A1A",
        }}
      />
      <motion.div
        aria-hidden="true"
        className="hidden md:block fixed top-0 left-0 pointer-events-none z-[9999]"
        style={{
          x: ringX,
          y: ringY,
          width: 32,
          height: 32,
          borderRadius: "9999px",
          border: "1px solid #C0C0C0",
          scale: ringScale,
        }}
      />
    </>
  );
}
